
   <div class="modal-content">

     <div class="modal-body">
       

       <div class="row mb-3">
        <div class="col-12 text-center">
          <h2>{{ 'LABELS.COMING_SOON' | translate }}</h2>
        </div>
      </div>
      <div class="row">
        
        <div class="text-center">
         <button type="button" class="btn fis-btn btn-min-size" data-bs-dismiss="modal"
         (click)="close()">{{ 'LABELS.OK' | translate}}</button>
       
        </div>
      </div>
     </div>

   </div><!-- /.modal-content -->

